import { useEffect } from 'react';
import translations from '../../../../../translations';
import { isNullOrEmpty } from '../../../../../utils/guard';
import FormGroup from '../../../../../components/generic/FormGroup';
import HTMLInput from '../../../../../components/generic/HTMLEditor/HTMLInput';
import { useMapElement } from '../../../../../components/flow/elementConfigurations/contextProviders/MapElementProvider';
import { useWait } from '../../../../../components/flow/elementConfigurations/contextProviders/WaitProvider';
import WaitInputs from '../../../../../components/flow/elementConfigurations/common/wait/WaitInputs';
import ModalBody from '../../../../../components/generic/modal/ModalBody';
import ModalFooter from '../../../../../components/generic/modal/ModalFooter';
import Footer from '../Footer';
import OutcomeList from '../outcomes/OutcomeList';

/**
 * The wait config screen
 */
const Wait = () => {
    const { mapElement, onSaveMapElement, onClose, setMapElement } = useMapElement();

    const {
        setHasSubmitted,
        isValidWait,
        initialWait,
        onWaitTypeChange,
        onSecondsChange,
        onMinutesChange,
        onHoursChange,
        onDaysChange,
        onTimezoneChange,
        onRelativeChange,
        onAbsoluteChange,
        onValueChanged,
        isMapElement,
        setIsMapElement,
        onUpdateName,
        onHeadlessChange,
    } = useWait();

    useEffect(() => {
        if (mapElement && isNullOrEmpty(mapElement.wait)) {
            setMapElement({
                ...mapElement,
                developerName: initialWait.developerName,
                wait: {
                    ...initialWait,
                },
            });
        }
        if (!isMapElement) {
            setIsMapElement(true);
        }
    });

    if (!mapElement) {
        onClose();
        return;
    }

    const renderBody = () => (
        <>
            <WaitInputs
                isMapElement={true}
                onWaitTypeChange={onWaitTypeChange}
                onUpdateName={onUpdateName}
                onSecondsChange={onSecondsChange}
                onMinutesChange={onMinutesChange}
                onHoursChange={onHoursChange}
                onDaysChange={onDaysChange}
                onTimezoneChange={onTimezoneChange}
                onRelativeChange={onRelativeChange}
                onAbsoluteChange={onAbsoluteChange}
                onValueChanged={onValueChanged}
                onHeadlessChange={onHeadlessChange}
            />
            <FormGroup label="Message to show users who are waiting">
                <HTMLInput
                    contentValue={mapElement.userContent ?? ''}
                    onChange={(event) => {
                        setMapElement({
                            ...mapElement,
                            userContent: event,
                            userContentDateModified: new Date().toISOString(),
                        });
                    }}
                    hasValuePickerPlugin={true}
                />
            </FormGroup>
            <OutcomeList />
            <FormGroup
                key="wait-comments"
                label={translations.WAIT_ELEMENT_comments_label}
                htmlFor="wait-comments"
            >
                <textarea
                    id="wait-comments"
                    className="form-control form-textarea"
                    value={mapElement.developerSummary ?? undefined}
                    onChange={({ target: { value } }) => {
                        setMapElement({
                            ...mapElement,
                            developerSummary: value,
                        });
                    }}
                />
            </FormGroup>
        </>
    );

    const renderFooter = () => {
        return <Footer save={saveWaitElement} cancel={onClose} />;
    };

    const saveWaitElement = () => {
        setHasSubmitted(true);
        if (isValidWait()) {
            onSaveMapElement(mapElement);
        }
    };

    return (
        <>
            <ModalBody>{renderBody()}</ModalBody>
            <ModalFooter>{renderFooter()}</ModalFooter>
        </>
    );
};

export default Wait;
